import { useEffect, useRef } from 'react'
import styles from './Downloads.module.scss'
import useHubSpotGenerate from 'hooks/useHubSpotGenerate'
import LeftContents from './LeftContents'
import { LeftContentDataType } from './types/types'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'

gsap.registerPlugin(ScrollTrigger)

const leftContentData: LeftContentDataType = {
  titleVol: <>AI-UXスプリントサービス紹介資料</>,
  alt: 'AI-UXスプリントサービス紹介資料',
  readText: (
    <>
      AI×UX専門家が曖昧な要件を最短2週間でプロトタイプ化。議論を加速し、本質的な体験設計を可能にするアプローチをご紹介します
    </>
  ),
  imgLarge: '/images/img/download/ai-ux-sprint/thumbnail_ai_ux_sprint.webp',
  imgCapture: '/images/img/download/ai-ux-sprint/capture_ai_ux_sprint.webp',
  firstContentTitle: 'このような方におすすめ',
  firstHalf: (
    <>
      認識合わせの会議で時間が溶け、曖昧な要件による致命的な手戻りに危機感を抱く方へ。バラバラな資料の構造化に悩み
      、AIによる「実務で使えないUI」の罠を回避したいなら
      、最短2週間で停滞を「議論できる体験」へ変える本手法をご活用ください。
    </>
  ),
  secondContentTitle: 'この資料でわかること',
  secondHalf1: '「整理・構築・精緻化」の3段階フレームワーク',
  secondHalf2: 'AIの圧倒的なスピードとUX専門家の審美眼を融合させた独自アプローチ',
  secondHalf3: '100画面規模のプロジェクトを成功に導いた実証成果',
  secondHalf4: '迷わず導入できる3つの投資プランと段階的ステップ',
}

const DownloadAIUXSprint: React.FC = () => {
  const title_category = useRef<HTMLSpanElement>(null)
  const title_page = useRef<HTMLSpanElement>(null)
  useHubSpotGenerate('na1', '9395227', '29f7a013-f39d-424f-a458-1eda0964cc39', '#hbspt')
  useEffect(() => {
    gsap.set([title_category.current, title_page.current, `.${styles.read_text}`, `.${styles.section}`], {
      opacity: 0,
      y: 50,
    })

    const timeline = gsap.timeline({
      defaults: {
        opacity: 0,
        y: 50,
        duration: 1,
        ease: Power4.easeOut,
      },
    })

    const commonTo = { opacity: 1, y: 0 }

    timeline
      .to(title_category.current, commonTo, 0.2)
      .to(title_page.current, commonTo, 0.5)
      .to(`.${styles.read_text}`, commonTo, 0.8)
      .to(`.${styles.section}`, commonTo, 1.1)
  }, [])

  return (
    <article className={`${styles.main} downloadArea`}>
      <section className={styles.contents}>
        <h1 className={styles.ttl}>
          <span ref={title_category}>Download</span>
          <span ref={title_page}>{leftContentData.titleVol}</span>
        </h1>
        <p className={styles.read_text}>{leftContentData.readText}</p>
        <section className={styles.section}>
          <LeftContents leftContentData={leftContentData} isSecondContent={true} />
          <div className={styles.content}>
            <div className={styles.title_group}>
              <p className={styles.whitepaper}>
                ご入力いただいたメールアドレス宛に、資料ダウンロード用URLを送付いたします。
              </p>
              <p className={styles.notice}>※ 全ての項目をご入力ください。</p>
            </div>
            <div id="hbspt"></div>
          </div>
        </section>
      </section>
      <MailmagazineLink />
    </article>
  )
}

export default DownloadAIUXSprint
